import { inject, Injectable } from '@angular/core';
import { ConfirmationService } from 'primeng/api';


@Injectable({
  providedIn: 'root'
})
export class ConfirmationDialogService {
   
    private readonly confirmationService = inject(ConfirmationService);
   
    show(message: string, acceptCallback: () => void): void {
        this.confirmationService.confirm({
            message: message,
            header: 'Attenzione',
            icon: 'pi pi-info-circle',
            rejectButtonStyleClass: 'p-button-text',
            rejectButtonProps: {
                label: 'Cancella',
                severity: 'secondary',
            },
            acceptButtonProps: {
                label: 'Conferma',
            },
            accept: () => {
                acceptCallback();
            },
        });
    }
}